import React, { useContext } from 'react';
import { Curious } from '@curi/react';
import PropTypes from 'prop-types';
import { NotificationContainer } from 'react-notifications';
import classNames from 'classnames';

import './App.css';
import '../../lib/css/appsflyer-banner.min.css';

import Header from '../../components/global/Header';
import Footer from '../../components/global/Footer';
import ExperimentsWrapper from '../../experiments/ExperimentsWrapper';
import { SubscriptionPlanProvider, SubscriptionPlansContext } from '../../subscriptionPlans/context';
import { getPlanLabelData } from '../../subscriptionPlans/planLabelData';
import { ExperimentContext } from '../../experiments/context';
import { FeatureFlagsProvider, useCodeSparkFlag } from '../../featureFlags';

const { detect, detectDevice } = require('../../services/detect-browser');
const deviceInfo = {
  browser: detect(),
  device: detectDevice()
};

function AppLayout({ children, isLanding }) {
  const { experiments: { homepageRedesign } } = useContext(ExperimentContext);
  const beginHeader = useCodeSparkFlag('codeSparkBeginHeader');

  return (
    <div
      className={classNames({
        'app-container': !homepageRedesign,
        'landing-container': isLanding,
        'with-begin-header': beginHeader,
      })}
    >
      {children}
    </div>
  );
}

class App extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);

    this.state = {
      isScrolling: false,
      isLanding: false,
      closeMenu: false
    };

    this._timeout = null;
    this.fixHeader = this.fixHeader.bind(this);
    this.goToLink = this.goToLink.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.fixHeader);

    let isLanding = (this.props.response.data && this.props.response.data.isLanding) ? this.props.response.data.isLanding : false;
    this.setState({ isLanding: isLanding });

  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.fixHeader);
  }

  fixHeader(e) {
    //supported by all browsers, including IE9+
    let scrollTop = window.pageYOffset; //https://www.w3schools.com/jsref/prop_win_pagexoffset.asp

    //if there is already a timeout in process cancel it
    if (this._timeout) {
      clearTimeout(this._timeout);
    }

    this._timeout = setTimeout(() => {
      this._timeout = null;
      if (scrollTop < 100) {
        this.setState({ isScrolling: false });
      }
    }, 100);

    if (scrollTop >= 100) {
      this.setState({ isScrolling: true });
    }
  }

  goToLink(e, link) {
    let windowType = e.ctrlKey ? '_blank' : '_self';
    window.open(link, windowType);
  }

  // clicking on global-overlay toggles the menu to close
  toggleOverlay() {
    if (this.state.closeMenu === true) {
      this.setState({closeMenu: false});
    } else {
      this.setState({closeMenu: true});
    }
  }

  getInitialPlansProps() {
    const { response: { data } } = this.props;

    if (data) {
      const { planTag, planOptions, selectedOfferId } = data;

      return {
        initialPlans: planOptions,
        initialOfferId: selectedOfferId,
        initialPlanTag: planTag
      }
    }

    return {}
  }

  render() {
    return (
      <FeatureFlagsProvider>
        <SubscriptionPlanProvider {...this.getInitialPlansProps()}>
          <SubscriptionPlansContext.Consumer>
            {({ planTag }) => {
              const planLabels = getPlanLabelData(planTag);

              return (
                <ExperimentsWrapper>
                  <AppLayout isLanding={this.state.isLanding}>
                      <Header
                        isScrolling={this.state.isScrolling}
                        isLanding={this.state.isLanding}
                        goToLink={this.goToLink}
                        closeMenu={this.state.closeMenu}
                        location={this.props.response.location}
                        planLabels={planLabels}
                        planTag={planTag}
                      />
                      <this.props.response.body
                        goToLink={this.goToLink}
                        deviceInfo={deviceInfo}
                        planLabels={planLabels}
                        planTag={planTag}
                      />
                      <Footer isLanding={this.state.isLanding} />
                      <NotificationContainer />
                      <div className="global-popup-overlay" onClick={() => this.toggleOverlay()}></div>
                    </AppLayout>
                </ExperimentsWrapper>
              );
            }}
          </SubscriptionPlansContext.Consumer>
        </SubscriptionPlanProvider>
      </FeatureFlagsProvider>
    );
  }
}

App.contextTypes = {
  mixpanel: PropTypes.object //not required because it won't be defined for server-side rendering
};

App.propTypes = {
  response: PropTypes.object.isRequired,
};

export default (props) => (
  <Curious>
    {({ response }) => {
      return <App response={response} {...props} />;
    }}
  </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/App/index.js